import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { translate } from 'react-i18next'
import ContentHeader from 'component/utils/ContentHeader'
import LmExpress from 'component/report/lmexpress/LmExpress'

class LmExpressContainer extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
  }

  render() {
    const { translate } = this.props

    return (
      <section>
        <ContentHeader>{translate('lmexpress.title')}</ContentHeader>

        <LmExpress translate={translate} />
      </section>
    )
  }
}

/*
 * Connects component to I18next
 */
const LmExpressTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(LmExpressContainer)

/*
 * Exports component connected to redux as default
 */
export { LmExpressContainer }
export default LmExpressTranslated
